import {Suspense, lazy} from 'react'
import Loader from "../../customs/loader/main"

const Main = lazy(() => import("../../components/settings/Setups/emailTemplate/main"))

const EmailTemplate = () => {
  return (
        <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
    
    
  )
}

export default EmailTemplate